import { Building2, ChevronDown, Loader2 } from "lucide-react"
import { useState } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import { fr } from "../../locales/fr"
import { Select } from "../ui/Select"

const linkBtnClass =
  "inline-flex h-9 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-border bg-secondary px-3 text-sm font-medium text-secondary-foreground transition-colors hover:bg-secondary/80"

export default function GymSwitcher() {
  const { gyms, activeGym, switchGym } = useAuth()
  const [switching, setSwitching] = useState(false)

  if (!activeGym) {
    return (
      <Link to="/settings/gyms" className={linkBtnClass}>
        <Building2 className="h-4 w-4" aria-hidden />
        {fr.gyms.manageLink}
      </Link>
    )
  }

  if (gyms.length <= 1) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex max-w-[200px] items-center gap-2 rounded-lg border border-border bg-muted/30 px-3 py-1.5 text-sm">
          <Building2 className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
          <span className="truncate font-medium text-foreground">{activeGym.name}</span>
        </div>
        <Link to="/settings/gyms" className={`${linkBtnClass} hidden sm:inline-flex`}>
          {fr.gyms.manageLink}
        </Link>
      </div>
    )
  }

  const handleChange = async (event) => {
    const gymId = Number(event.target.value)
    if (!gymId || gymId === activeGym.id || switching) return
    setSwitching(true)
    try {
      await switchGym(gymId)
    } catch (error) {
      console.error(error)
      setSwitching(false)
    }
  }

  return (
    <div className="flex items-center gap-2">
      {switching ? (
        <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" aria-hidden />
      ) : (
        <Building2 className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
      )}
      <div className="relative">
        <Select
          value={String(activeGym.id)}
          onChange={handleChange}
          disabled={switching}
          className="h-9 w-[min(220px,42vw)] pr-8 text-sm"
          aria-label={fr.gyms.switcherLabel}
        >
          {gyms.map((gym) => (
            <option key={gym.id} value={gym.id}>
              {gym.name}
              {gym.city ? ` — ${gym.city}` : ""}
            </option>
          ))}
        </Select>
        <ChevronDown
          className="pointer-events-none absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
          aria-hidden
        />
      </div>
      <Link
        to="/settings/gyms"
        className="hidden h-9 items-center px-2 text-sm text-muted-foreground hover:text-foreground lg:inline-flex"
      >
        {fr.gyms.manageLink}
      </Link>
    </div>
  )
}
